import CreatedAt from './components/CreatedAt'
import OrganizationName from './components/OrganizationName'
import TransferOwner from './components/TransferOwner'
import { NewSettingsPageLayout } from '../shared/components/NewSettingsPageLayout'

import type { JSX } from 'react'

const GeneralSettings = (): JSX.Element => {
  return (
    <NewSettingsPageLayout title="General" gap="md">
      <CreatedAt />
      <OrganizationName />
      <TransferOwner />
    </NewSettingsPageLayout>
  )
}

export default GeneralSettings
